/* Flourish Heritage – header slide-out menu (Theme-5).
   Delegated listeners, so it keeps working after the theme editor re-renders the header. */
(function () {
  if (window.__fhDrawer) return;
  window.__fhDrawer = true;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastOpener = null, closeTimer = null;

  function drawer() { return document.querySelector('[data-fh-drawer]'); }
  function openers() { return document.querySelectorAll('[data-fh-drawer-open]'); }
  function setExpanded(v) { openers().forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); }); }
  function lock(on) {
    var b = document.body;
    if (on) {
      var sw = window.innerWidth - document.documentElement.clientWidth;
      if (sw > 0) b.style.paddingRight = sw + 'px';
      b.classList.add('fh-drawer-lock');
    } else {
      b.classList.remove('fh-drawer-lock');
      b.style.paddingRight = '';
    }
  }
  function isOpen() { var d = drawer(); return !!(d && d.classList.contains('is-open')); }

  function open(opener) {
    var d = drawer(); if (!d) return;
    clearTimeout(closeTimer);
    lastOpener = opener || document.activeElement;
    d.hidden = false;
    document.body.classList.add('fh-drawer-raise');
    void d.offsetWidth; // let the closed state paint so the slide-in transitions
    d.classList.add('is-open');
    setExpanded(true); lock(true);
    var c = d.querySelector('.fh-drawer__close');
    if (c) c.focus({ preventScroll: true });
  }
  function close(returnFocus) {
    var d = drawer(); if (!d || !isOpen()) return;
    d.classList.remove('is-open');
    setExpanded(false); lock(false);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    closeTimer = setTimeout(function () { if (!d.classList.contains('is-open')) { d.hidden = true; document.body.classList.remove('fh-drawer-raise'); } }, reduce ? 0 : 430);
    if (returnFocus !== false && lastOpener && document.contains(lastOpener) && lastOpener.offsetParent !== null) lastOpener.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var o = t.closest('[data-fh-drawer-open]');
    if (o) { e.preventDefault(); isOpen() ? close() : open(o); return; }
    if (t.closest('[data-fh-drawer-close]')) { e.preventDefault(); close(); return; }
    // Promo button opens a Klaviyo popup (snippets/fh-guide-trigger.liquid); close the drawer so it shows on top.
    if (t.closest('.fh-drawer .fh-guide-trigger[data-klaviyo-form]')) close(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var panel = drawer().querySelector('.fh-drawer__panel');
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Desktop <-> phone resize: nothing to re-layout, but never leave the page locked behind a closed drawer.
  window.addEventListener('pageshow', function () { if (!isOpen()) lock(false); });

  // Theme editor: the header is re-rendered on shopify:section:load; reset state so the new markup starts closed.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-fh-drawer]')) { lock(false); }
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector || !e.target.querySelector('[data-fh-drawer]')) return;
      lock(false); setExpanded(false); lastOpener = null; document.body.classList.remove('fh-drawer-raise');
    });
  }
})();
